import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import { DataSurveyState } from '../reducers/data-survey.reducers';

export const getDataSurveyState = createFeatureSelector<DataSurveyState>(
  'data-survey-state'
);

export const getCurrentSurvey = createSelector(
  getDataSurveyState,
  (state: DataSurveyState) => state.currentSurvey
);